<template>
  <RadioGroup v-model="data.value" @change="bindChange">
    <RadioItem
      v-for="(item, index) in data.options"
      :key="index"
      :value="item.key"
      :theme="theme"
    >
      <div>
        <div
          class="radio-text"
          :style="{
            background:
              data.value == item.key ? theme.checkColor : theme.notCheckColor
          }"
          v-if="
            (item.value && !item.que_answer_icon) ||
            loadImageData[index].imageLoadError
          "
          >{{ item.value }}</div
        >
        <div
          class="radio-image"
          v-if="item.que_answer_icon && !loadImageData[index].imageLoadError"
        >
          <img
            style="width: 100%"
            :src="item.que_answer_icon"
            alt=""
            @error="bindLoadError(index)"
          />
          <div
            class="active iconfont icon-gou"
            v-if="!loadImageData[index].imageLoadError"
            v-show="data.value == item.key"
            :style="{ background: theme.checkColor }"
          ></div>
        </div>
        <div
          @click.stop
          v-if="item.que_answer_attr && data.value == item.key"
          class="raido-input"
        >
          <van-field
            v-model="item.inputValue"
            rows="3"
            type="textarea"
            placeholder="请输入(选填)"
          />
        </div>
      </div>
    </RadioItem>
  </RadioGroup>
</template>
<script>
import RadioItem from './raido/radio.vue'
import RadioGroup from './raido/radio-group.vue'
import Bus from '@/utils/bus' // 引入事件总线
export default {
  components: {
    RadioGroup,
    RadioItem
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loadImageData: [],
      loadError: false //图片加载失败
    }
  },
  created() {
    this.loadImageData = this.data.options.map(() => {
      return {
        imageLoadError: false
      }
    })
  },
  methods: {
    bindChange(value) {
      this.autoScroll(value)
      this.$emit('change', value)
    },
    bindLoadError(index) {
      this.loadImageData[index].imageLoadError = true
    },
    autoScroll(value) {
      this.data.options.map((item) => {
        if (item.key == value && item.que_answer_attr) {
          //如果是其他选项，则滚动到最底下，避免看不到输入框
          this.$nextTick(() => {
            Bus.$emit('commonQuestionRadioSelectOther')
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-text {
  padding: 14px 16px;
  box-sizing: border-box;
  background: #f5f6fa;
  border-radius: 8px;
}

.raido-input {
  margin-top: 10px;
  width: 100%;
  border: 1px solid #eee;
  box-sizing: border-box;
}

.radio-image {
  position: relative;

  .active {
    position: absolute;
    right: 24px;
    top: 50%;
    color: #fff;
    transform: translate(0%, -50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #9f91fe;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
